import React, { useEffect, useState, useRef } from "react";
import { Card, Col, Row, Breadcrumb, Form, Spin } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { t } from "i18next";
import { getRequest } from "../../axios";

export default function CategorySelectionForRFQ() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");

  const [apiLoading, setapiLoading] = useState(false);
  const [categoryTreeData, setCategoryTreeData] = useState([]);
  const navigate = useNavigate();

  const handleCategoryClick = (key) => {
    setSelectedCategory(key.id);
    setSelectedCategoryName(key.name);
    navigate(`/purchase-requisition-assign/${key.id}/`, {
      state: {
        categoryId: key.id,
        selectedCategoryName: key.name,
      },
    });
  };

  const Categorytree = async () => {
    setapiLoading(true);
    try {
      const fields = ["id", "name", "description", "image"].join(
        ","
      );
      const queryParams = new URLSearchParams();
      queryParams.set("fields", fields);

      const response = await getRequest(
        `category-tree/?${queryParams.toString()}`

      );
      const data = response.data?.results?.data || [];

      const filteredData = data.filter(
        (item) => item.unit_of_measurement !== "KG"
      );
      const sortedData = filteredData.sort((a, b) => a.id - b.id);

      setCategoryTreeData(sortedData);
    } catch (error) {
      console.error("Category tree fetch error:", error);
    } finally {
      setapiLoading(false);
    }
  };

  useEffect(() => {
    Categorytree();
  }, []);

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Select category for RFQ</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Select category for RFQ</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="stepscontentwrap">
        <div className="stepsContent">
          <Spin spinning={apiLoading}>
            <Row gutter={16} style={{ marginBottom: 32 }}>
              {categoryTreeData.map((cat) => (
                <Col key={cat.id}>
                  <Card
                    hoverable
                    style={{
                      width: 160,
                      marginBottom: "10px",
                      height: 180,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      border:
                        selectedCategory === cat.id
                          ? "2px solid #1677ff"
                          : "1px solid #d9d9d9",
                    }}
                    onClick={() => handleCategoryClick(cat)}
                  >
                    <img
                      src={cat.image}
                      alt={cat.name}
                      style={{ height: 80, objectFit: "contain" }}
                    />
                    <div style={{ marginTop: 12, fontWeight: 500 }}>
                      {cat.name}
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </Spin>
        </div>
      </section>
    </>
  );
}
